package com.myfield.app.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.myfield.app.style.TextSelectionStyle
import com.myfield.app.util.BackgroundGradient
import com.myfield.app.util.Constants.ACME_REGULAR
import com.myfield.app.util.Constants.LATO_LIGHT
import com.myfield.app.util.Constants.LATO_REGULAR
import com.myfield.app.util.Constants.SUPPORT_EMAIL
import com.myfield.app.util.TextGradient
import com.myfield.app.util.Theme
import com.varabyte.kobweb.compose.css.BackgroundClip
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.H2
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@OptIn(DelicateApi::class)
@Composable
@Page
fun TermsOfServicePage() {
    val breakpoint = rememberBreakpoint()
    val largeBreakpoint = remember(breakpoint) {
        breakpoint > Breakpoint.LG
    }

    Box(
        modifier = Modifier.fillMaxSize(),
        contentAlignment = Alignment.TopCenter
    ) {
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .backgroundImage(BackgroundGradient)
                .padding(
                    leftRight = if (breakpoint > Breakpoint.LG) 120.px
                    else if (breakpoint == Breakpoint.LG) 100.px
                    else if (breakpoint > Breakpoint.MD) 70.px
                    else if (breakpoint == Breakpoint.MD) 50.px
                    else 16.px
                ),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .maxWidth(if (largeBreakpoint) 800.px else 600.px)
                    .padding(bottom = 100.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                // Main Title
                H1(
                    attrs = TextSelectionStyle.toModifier()
                        .fillMaxWidth()
                        .margin(bottom = 20.px, top = if (largeBreakpoint) 50.px else 20.px)
                        .backgroundImage(TextGradient)
                        .background { this.clip(BackgroundClip.Text) }
                        .color(Color.transparent)
                        .fontFamily(ACME_REGULAR)
                        .fontSize(if (largeBreakpoint) 4.cssRem else 2.4.cssRem)
                        .lineHeight(1.2)
                        .textAlign(TextAlign.Center)
                        .toAttrs()
                ) {
                    Text("Умови використання")
                }

                // Subtitle Information
                P(
                    attrs = TextSelectionStyle.toModifier()
                        .fillMaxWidth()
                        .margin(bottom = 40.px)
                        .color(Theme.TextLowVisibility.rgb)
                        .fontFamily(LATO_REGULAR)
                        .fontSize(1.1.cssRem)
                        .lineHeight(1.4)
                        .textAlign(TextAlign.Center)
                        .toAttrs()
                ) {
                    Text("Дата набрання чинності: 08.05.2026")
                }

                Surface(modifier = Modifier.height(20.px)) {}

                // Introduction
                P(
                    attrs = TextSelectionStyle.toModifier()
                        .fillMaxWidth()
                        .margin(bottom = 40.px)
                        .color(Theme.Text.rgb)
                        .fontFamily(LATO_REGULAR)
                        .fontSize(1.1.cssRem)
                        .lineHeight(1.6)
                        .textAlign(TextAlign.Start)
                        .toAttrs()
                ) {
                    Text("Ласкаво просимо до MyField! Ці Умови використання («Умови») регулюють використання вами мобільного застосунку MyField («Застосунок»). Завантажуючи, відкриваючи або використовуючи MyField, ви погоджуєтесь з цими Умовами. Якщо ви не погоджуєтесь — будь ласка, не використовуйте Застосунок.")
                }

                // Section 1
                SectionTitle("1. Опис сервісу", largeBreakpoint)
                SectionContent("MyField — застосунок для управління сільськогосподарським господарством, що допомагає вести облік полів, культур, врожаю, закупівель, продажів, фінансових операцій, працівників, орендодавців та аналітики.")
                SectionContent("Сервіс надається для законних сільськогосподарських та ділових цілей.")

                // Section 2
                SectionTitle("2. Облікові записи", largeBreakpoint)
                SectionContent("Для використання MyField необхідно створити обліковий запис, вказавши ім'я, електронну адресу та пароль. Після реєстрації потрібно підтвердити електронну адресу для активації акаунту. Використовуючи застосунок, ви підтверджуєте, що вам виповнилося 16 років.")
                SectionContent("Ви погоджуєтесь:")
                SectionContent("• Надавати точну та повну інформацію під час реєстрації")
                SectionContent("• Зберігати безпеку своїх облікових даних і не передавати доступ іншим особам")
                SectionContent("• Використовувати застосунок лише в законних цілях")
                SectionContent("• Негайно повідомити нас у разі підозри на несанкціонований доступ до вашого акаунту")
                Surface(modifier = Modifier.height(20.px)) {}
                SectionContent("Ви несете відповідальність за всі дії, що здійснюються під вашим обліковим записом.")

                // Section 3
                SectionTitle("3. Допустиме використання", largeBreakpoint)
                SectionContent("Ви погоджуєтесь не:")
                SectionContent("• Використовувати застосунок у незаконних або несанкціонованих цілях")
                SectionContent("• Намагатися отримати несанкціонований доступ до застосунку або його систем")
                SectionContent("• Порушувати або перешкоджати роботі застосунку чи серверів")
                SectionContent("• Здійснювати реверс-інжиніринг, копіювання або експлуатацію сервісів без дозволу")
                SectionContent("• Вводити неправдиві, оманливі або шахрайські дані в застосунок")
                SectionContent("• Використовувати автоматизовані засоби (боти, скрапери) для доступу до застосунку або його даних без нашого дозволу")

                // Section 4
                SectionTitle("4. Дані та контент користувача", largeBreakpoint)
                SectionContent("Ви зберігаєте право власності на всі дані та контент, які створюєте в застосунку, зокрема:")
                SectionContent("• Записи про поля та культури")
                SectionContent("• Фінансові та операційні записи")
                SectionContent("• Інформацію про працівників, орендодавців та кредиторів")
                SectionContent("• Записи про врожай, закупівлі та продажі")
                SectionContent("• Аналітичні дані")
                Surface(modifier = Modifier.height(20.px)) {}
                SectionContent("Використовуючи MyField, ви надаєте нам дозвіл зберігати та обробляти ці дані, включаючи резервне копіювання для забезпечення надійності сервісу, виключно для забезпечення функціональності застосунку.")

                // Section 5
                SectionTitle("5. Видалення акаунту та даних", largeBreakpoint)
                SectionContent("Ви можете видалити свій обліковий запис у будь-який час через застосунок.")
                SectionContent("Після видалення:")
                SectionContent("• Ваші активні сесії негайно припиняються")
                SectionContent("• Ваш акаунт та пов'язані дані будуть видалені з наших систем після обробки запиту на видалення")
                SectionContent("• Ця дія є незворотною — видалені дані не можуть бути відновлені")
                Surface(modifier = Modifier.height(20.px)) {}
                SectionContent("Для негайного видалення всіх даних зверніться до нас за адресою з розділу «Контактна інформація».")

                // Section 6
                SectionTitle("6. Доступність сервісу", largeBreakpoint)
                SectionContent("Ми прагнемо надавати надійний сервіс, але не гарантуємо безперебійну або безпомилкову роботу.")
                SectionContent("Ми залишаємо за собою право:")
                SectionContent("• Змінювати або припиняти функції в будь-який час")
                SectionContent("• Проводити технічне обслуговування, яке може тимчасово обмежити доступ")
                SectionContent("• Оновлювати застосунок для покращення функціональності або безпеки")
                Surface(modifier = Modifier.height(20.px)) {}
                SectionContent("Ми не несемо відповідальності за втрату даних або недоступність сервісу під час технічного обслуговування чи збоїв.")

                // Section 7
                SectionTitle("7. Припинення дії облікового запису", largeBreakpoint)
                SectionContent("Ви можете припинити використання MyField у будь-який час.")
                SectionContent("Ми залишаємо за собою право призупинити або припинити дію облікових записів, які:")
                SectionContent("• Порушують ці Умови")
                SectionContent("• Беруть участь у образливій або шкідливій поведінці щодо сервісу або інших користувачів")
                Surface(modifier = Modifier.height(20.px)) {}
                SectionContent("У більшості випадків ми надамо попередження перед призупиненням облікового запису, крім випадків серйозних або повторних порушень цих Умов.")
                Surface(modifier = Modifier.height(20.px)) {}
                SectionContent("Після припинення дії ваші дані будуть оброблені відповідно до нашої Політики конфіденційності.")

                // Section 8
                SectionTitle("8. Інтелектуальна власність", largeBreakpoint)
                SectionContent("Усі права, назва та інтереси щодо MyField — включаючи дизайн, брендинг, логотипи та програмне забезпечення — залишаються нашою власністю.")
                SectionContent("Використання застосунку також регулюється умовами використання App Store (Apple Inc.) або Google Play (Google LLC), залежно від того, звідки ви завантажили застосунок.")
                SectionContent("Apple Inc. та Google LLC є третіми сторонами-бенефіціарами цих Умов щодо використання застосунку, завантаженого з App Store або Google Play відповідно, та мають право застосовувати ці Умови.")
                SectionContent("Ви не можете використовувати наш брендинг або активи без попереднього письмового дозволу.")
                SectionContent("Усі відгуки, пропозиції або ідеї, надані вами щодо застосунку, стають нашою власністю без будь-яких зобов'язань з нашого боку.")

                // Section 9
                SectionTitle("9. Обмеження відповідальності", largeBreakpoint)
                SectionContent("MyField надається «як є» та «як доступно». Ми не гарантуємо, що застосунок відповідатиме вашим конкретним потребам або що результати його використання будуть точними чи надійними.")
                SectionContent("Ми не несемо відповідальності за:")
                SectionContent("• Втрату даних або записів, введених у застосунок")
                SectionContent("• Фінансові втрати, спричинені рішеннями, прийнятими на основі даних або аналітики застосунку")
                SectionContent("• Неточності в розрахунках або аналітичних результатах")
                SectionContent("• Перебої в роботі сервісу або недоступність даних")
                Surface(modifier = Modifier.height(20.px)) {}
                SectionContent("У максимальному обсязі, дозволеному застосовним законодавством, ми не несемо відповідальності за будь-які непрямі, випадкові або побічні збитки, включаючи втрату прибутку, втрату даних або репутаційні збитки, навіть якщо нас було повідомлено про можливість таких збитків. Це обмеження не застосовується у випадках, коли відповідальність не може бути обмежена відповідно до закону.")
                Surface(modifier = Modifier.height(20.px)) {}
                SectionContent("Використання застосунку та покладання на його дані здійснюється на ваш власний ризик. Рекомендується вести незалежний облік критично важливих ділових та фінансових даних.")

                // Section 10
                SectionTitle("10. Зміни до цих Умов", largeBreakpoint)
                SectionContent("Ми можемо час від часу оновлювати ці Умови. Про будь-які суттєві зміни буде повідомлено через застосунок або електронну пошту.")
                Surface(modifier = Modifier.height(20.px)) {}
                SectionContent("Продовження використання застосунку після публікації змін означає прийняття оновлених Умов.")

                // Section 11
                SectionTitle("11. Підписка та оплата", largeBreakpoint)
                SectionContent("MyField пропонує платну підписку «MyField Pro», яка надає доступ до повного функціоналу застосунку. Підписка доступна у двох варіантах: місячна та річна.")
                SectionContent("Оплата та виставлення рахунків:")
                SectionContent("• Оплата здійснюється через ваш обліковий запис App Store (Apple) або Google Play (Google) після підтвердження покупки")
                SectionContent("• Ціни відображаються у застосунку перед оформленням підписки")
                SectionContent("• Підписка автоматично поновлюється наприкінці кожного розрахункового періоду (місяць або рік), якщо ви не скасуєте її щонайменше за 24 години до закінчення поточного періоду")
                SectionContent("• Кошти списуються з вашого облікового запису App Store або Google Play протягом 24 годин до закінчення поточного розрахункового періоду")
                SectionContent("Скасування та доступ:")
                SectionContent("• Ви можете скасувати підписку в будь-який час через налаштування вашого облікового запису App Store або Google Play")
                SectionContent("• Після скасування підписка залишається активною до кінця оплаченого розрахункового періоду — доступ до функцій зберігається до цієї дати")
                SectionContent("• Скасування підписки не призводить до негайного припинення доступу та не передбачає повернення коштів за невикористаний період")
                SectionContent("Повернення коштів:")
                SectionContent("• Усі питання повернення коштів регулюються виключно правилами App Store (Apple) або Google Play (Google) — залежно від того, де ви оформили підписку")
                SectionContent("• MyField не обробляє повернення коштів безпосередньо")
                SectionContent("Відновлення покупок:")
                SectionContent("• Якщо ви раніше оформили підписку, ви можете відновити її через розділ «Підписка» в застосунку за допомогою кнопки «Відновити підписку»")
                SectionContent("• Відновлення покупок прив'язане до вашого облікового запису App Store або Google Play, а не до облікового запису MyField")

                // Section 12
                SectionTitle("12. Застосовне право", largeBreakpoint)
                SectionContent("Ці Умови регулюються та тлумачаться відповідно до законодавства України без урахування принципів колізійного права, за винятком випадків, коли це суперечить обов'язковим вимогам App Store (Apple) або Google Play (Google). Якщо ви використовуєте застосунок за межами України, ви також зобов'язані дотримуватися місцевого законодавства.")
                Surface(modifier = Modifier.height(20.px)) {}
                SectionContent("Будь-які спори, що виникають з цих Умов, підлягають вирішенню у судах України.")
                Surface(modifier = Modifier.height(20.px)) {}
                SectionContent("Якщо будь-яке положення цих Умов визнається недійсним або таким, що не може бути виконане, решта Умов залишається в повній силі та продовжує діяти.")

                // Section 13
                SectionTitle("13. Контактна інформація", largeBreakpoint)
                SectionContent("З питань щодо цих Умов, будь ласка, зв'яжіться з нами:")
                P(
                    attrs = TextSelectionStyle.toModifier()
                        .fillMaxWidth()
                        .margin(topBottom = 10.px)
                        .color(Theme.Text.rgb)
                        .fontFamily(LATO_REGULAR)
                        .fontSize(1.1.cssRem)
                        .lineHeight(1.6)
                        .textAlign(TextAlign.Start)
                        .toAttrs()
                ) {
                    Text(SUPPORT_EMAIL)
                }
            }
        }
    }
}

@Composable
private fun SectionTitle(
    text: String,
    largeBreakpoint: Boolean,
) {
    Surface(modifier = Modifier.height(30.px)) {}
    H2(
        attrs = TextSelectionStyle.toModifier()
            .fillMaxWidth()
            .margin(bottom = 20.px)
            .color(Theme.Text.rgb)
            .fontFamily(LATO_LIGHT)
            .fontSize(if (largeBreakpoint) 1.8.cssRem else 1.6.cssRem)
            .lineHeight(1.3)
            .textAlign(TextAlign.Start)
            .toAttrs()
    ) {
        Text(text)
    }
}

@Composable
private fun SectionContent(
    text: String,
) {
    P(
        attrs = TextSelectionStyle.toModifier()
            .fillMaxWidth()
            .margin(bottom = 15.px)
            .color(Theme.TextLowVisibility.rgb)
            .fontFamily(LATO_LIGHT)
            .fontSize(1.1.cssRem)
            .lineHeight(1.6)
            .textAlign(TextAlign.Start)
            .toAttrs()
    ) {
        Text(text)
    }
}